import React, { useEffect, useState } from "react";
import { Box, Grid, InputAdornment, InputLabel, MenuItem, OutlinedInput, Select, SelectChangeEvent, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import Agency from "../../Image/Agency.png";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import axios from "axios";
import { APIEndpoint } from "../../client/apiconfig";
import SearchIcon from '@mui/icons-material/Search';
import Swal from "sweetalert2";
import { useHistory } from "react-router-dom";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

interface IDataPer {
  name_th: string;
  organization: IDataOrganization

}

interface IDataOrganization {
  map(arg0: (org: any) => import("react/jsx-runtime").JSX.Element): React.ReactNode;
  name_th: string;
  hcode: string;
  hname_eng: string;
  hname_th: string;

}



const SelectAgency: React.FC = (): JSX.Element => {
  const [serviceArea, setServiceArea] = useState<any>(null);
  const [selectedValueAgency, setSelectedValueAgency] = useState<any>(null);
  const [dataPersonal, setDataPersonal] = useState<IDataPer | null>(null);
  // const [serviceAreas, setServiceAreas] = React.useState<any[]>([]);
  const history = useHistory();

  // Todo Use Effect for get all user organization from local storage
  useEffect(() => {
    // Todo Get Data from Local Storage
    const storedData = sessionStorage.getItem("Data");
    setDataPersonal(storedData ? JSON.parse(storedData).result.data : null);
  
    if (storedData) {
      try {
        const userData = JSON.parse(storedData);
        const tokenType = userData?.result?.token_type;
  
        // 🔹 ถ้าเป็น health_id → ข้ามการเช็ค organization และเข้า document-personal ทันที
        if (tokenType === "health_id") {
          history.push("/document-personal");
          return;
        }
  
        // 🔹 ถ้าเป็น provider_id → เช็คข้อมูล organization และเลือกสังกัดแรก
        if (tokenType === "provider_id") {
          if (userData.result?.data?.organization) {
            const areas = userData.result.data.organization.map((org: any) => ({
              label: org.hname_th,
              value: org.hcode,
            }));
  
            if (areas.length > 0) {
              setServiceArea(areas[0]); // เลือกต้นสังกัดอันแรกอัตโนมัติ
            } else {
              // Todo Inform user that error occurred and redirect to Login Page.
              Swal.fire({
                icon: "error",
                title: "เกิดข้อผิดพลาด",
                text: "ไม่พบข้อมูลสังกัดของผู้ใช้งาน กรุณาติดต่อเจ้าหน้าที่",
                confirmButtonText: "ตกลง",
              });
              history.push("/");
              return;
            }
          }
        }
      } catch (error) {
        console.error("Error parsing localStorage data:", error);
        history.push("/");
        Swal.fire({
          icon: "error",
          title: "เกิดข้อผิดพลาด",
          text: "ไม่สามารถโหลดข้อมูลสังกัดได้ กรุณาเข้าสู่ระบบใหม่",
          confirmButtonText: "ตกลง",
        });
      }
    } else {
      // Todo Inform user that error occurred and redirect to Login Page.
      Swal.fire({
        icon: "warning",
        title: "ไม่พบข้อมูลผู้ใช้งาน",
        text: "กรุณาเข้าสู่ระบบก่อนเข้าถึงหน้านี้",
        confirmButtonText: "ตกลง",
      });
      history.push("/");
    }
  }, []);
  
  useEffect(() => {
    if (serviceArea) {
      register();
    }
  }, [serviceArea]);
  
  
  
  useEffect(() => {
      // Todo Get Data from Local Storage
      const storedData = sessionStorage.getItem("Data");
      setDataPersonal(storedData ? JSON.parse(storedData).result.data : null)
      if (storedData) {
        try {
          const userData = JSON.parse(storedData);
          
          if (userData.result?.data?.organization) {
            const areas = userData.result.data.organization.map((org: any) => ({
              label: org.hname_th,
              value: org.hcode,
            }));
            // setServiceAreas(areas);
  
            if (areas.length > 0) {
              setServiceArea(areas[0]); // เลือกต้นสังกัดอันแรกอัตโนมัติ
            } else {
              // Todo Inform user that error occurred and redirect to Login Page.
              Swal.fire({
                icon: "error",
                title: "เกิดข้อผิดพลาด",
                text: "ไม่พบข้อมูลสังกัดของผู้ใช้งาน กรุณาติดต่อเจ้าหน้าที่",
                confirmButtonText: "ตกลง",
              });
              history.push("/");
  
              return;
            }
          }
        } catch (error) {
          console.error("Error parsing localStorage data:", error);
          history.push("/");
          Swal.fire({
            icon: "error",
            title: "เกิดข้อผิดพลาด",
            text: "ไม่สามารถโหลดข้อมูลสังกัดได้ กรุณาเข้าสู่ระบบใหม่",
            confirmButtonText: "ตกลง",
          });
        }
      } else {
        // Todo Inform user that error occurred and redirect to Login Page.
        Swal.fire({
          icon: "warning",
          title: "ไม่พบข้อมูลผู้ใช้งาน",
          text: "กรุณาเข้าสู่ระบบก่อนเข้าถึงหน้านี้",
          confirmButtonText: "ตกลง",
        });
        history.push("/");
      }
    }, []);
  

  useEffect(() => {
    if (serviceArea) {
      register();
    }
  }, [serviceArea]);

  const register = async () => {
    if (serviceArea) {
      const storedDataPerson = sessionStorage.getItem("Data");
      if (!storedDataPerson) {
        // Todo Alert Error and redirect to Login Page
        Swal.fire({
          icon: "error",
          title: "เกิดข้อผิดพลาด",
          text: "ไม่พบข้อมูลผู้ใช้งาน กรุณาติดต่อเจ้าหน้าที่",
          confirmButtonText: "ตกลง",
        });
        history.push("/");

        return;
      }
      try {
        const parsedDataPerson = JSON.parse(storedDataPerson);
        const organizations = parsedDataPerson?.result?.data?.organization;
        if (organizations && organizations.length > 0) {
          const matchedOrganization = organizations.find(
            (org: any) => String(org.hcode) === String(serviceArea.value)
          );

          sessionStorage.setItem(
            "position",
            JSON.stringify(matchedOrganization.position)
          );
          sessionStorage.setItem(
            "hcode",
            JSON.stringify(matchedOrganization.hcode)
          );

          if (matchedOrganization) {
            // const filteredData = {
            //   hospital_code: matchedOrganization.hcode,
            //   person_type: matchedOrganization.position,
            //   department: matchedOrganization.affiliation,
            //   tax_id: matchedOrganization.tax_id,
            //   license_no: matchedOrganization.license_id,
            //   address: matchedOrganization.address.address,
            //   tambon: matchedOrganization.address.sub_district,
            //   district: matchedOrganization.address.district,
            //   province: matchedOrganization.address.province,
            //   zip_code: matchedOrganization.address.zip_code,
            //   account_id: parsedDataPerson.result.data.account_id,
            //   cid_hash: parsedDataPerson.result.data.hash_cid,
            //   prefix: parsedDataPerson.result.data.title_th,
            //   first_name_th: parsedDataPerson.result.data.firstname_th,
            //   middle_name_th: parsedDataPerson.result.data.special_title_th,
            //   last_name_th: parsedDataPerson.result.data.lastname_th,
            //   first_name_en: parsedDataPerson.result.data.firstname_en,
            //   middle_name_en: parsedDataPerson.result.data.special_title_en,
            //   last_name_en: parsedDataPerson.result.data.lastname_en,
            //   hospital_name: matchedOrganization.hname_th,
            // };

            // เช็ค role และเลือก API ที่จะใช้
            // const apiEndpoint =
            //   parsedDataPerson.result.role === "PERSON"
            //     ? APIEndpoint.RegisterPerson
            //     : APIEndpoint.RegisterStaff;

            // // TODO make object data for send to Register API
            // const userData = {
            //   "user_profile": {
            //     "data": parsedDataPerson.result.data,
            //     "username": parsedDataPerson.result.username,
            //   },
            //   "token_type": "provider_id",
            //   "access_token": parsedDataPerson.result.provider_access_token,
            // }

            // // TODO Call Register API
            // const response = await axios.post(
            //   APIEndpoint.Register,
            //   userData,
            //   {
            //     auth: BasicAuthUser,
            //   }
            // );

            // if (response) {
            //   console.log("Register response: ", response.data);
            // }

            // Todo Route to Personal Document Page.
            // history.push("/document-personal");
          } else {
            // Todo throw error "No matching organization found for the selected hcode"
            throw new Error(
              "No matching organization found for the selected hcode"
            );
          }
        }
      } catch (error) {
        // Todo Alert Error and redirect to Login Page
        Swal.fire({
          icon: "error",
          title: "เกิดข้อผิดพลาด",
          text: "ไม่สามารถลงทะเบียนข้อมูลได้ กรุณาติดต่อเจ้าหน้าที่",
          confirmButtonText: "ตกลง",
        });
        history.push("/");
        console.error("Select Agency Page error happened: ", error);

        return;
      }
    } else {
      // Todo Alert Error and redirect to Login Page
      Swal.fire({
        icon: "error",
        title: "เกิดข้อผิดพลาด",
        text: "ไม่พบข้อมูลข้อมูลสังกัดของผู้ใช้งาน กรุณาติดต่อเจ้าหน้าที่",
        confirmButtonText: "ตกลง",
      });
      history.push("/");

      return;
    }
  };

  const handleChangeAgency = (event: SelectChangeEvent<string>) => {
    setSelectedValueAgency(event.target.value)
  };


  const confirmAgency = async ()  => {
  await sessionStorage.setItem("organization", JSON.stringify(selectedValueAgency));
  history.push("/document-personal");

  };


  return (
    <Grid container justifyContent="center">
      <Grid
        container
        sx={{
          height: "100vh",
          alignContent: "center",
          justifyContent: "center",
          // flexDirection: { xs: "column", md: "row" }
        }}
      >

        {/* Left Section - Form */}
        <Grid item xs={12} md={7}

          sx={{
            backgroundColor: "#ffffff",
            p: 2,
            maxHeight: 530,
            borderTopLeftRadius: 12,
            borderBottomLeftRadius: 12
          }}>
          <Box display={'grid'} alignContent={'center'} sx={{ height: '100%' }}>
            <Grid item xs={12} mb={4} display="flex" justifyContent="center">
              <Typography sx={{ color: "#003154" }} fontSize={18} fontWeight={600}>
                กรุณาเลือกต้นสังกัด
              </Typography>
            </Grid>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <Grid item xs={10}  >
                <Select
                  value={selectedValueAgency}
                  onChange={handleChangeAgency}
                  displayEmpty
                  variant="outlined"
                  renderValue={(selected:any) => {
                    return selected && typeof selected === "object" ? selected?.hname_th : "เลือกสังกัด";
                  }}
                  sx={{
                    width: "100%",
                    "& .MuiOutlinedInput-root": { borderRadius: "26px" },
                    "& fieldset": { borderRadius: "26px" },
                    height: 42,
                  }}

                >
                  {dataPersonal && dataPersonal.organization.map((org) => (
                  <MenuItem key={org.hcode} value={org}>
                    {org.hname_th}
                  </MenuItem>
                ))}
                </Select>

              </Grid>
            </div>
            <Grid item justifyContent={'center'} display={'flex'}>
              <Button
                disabled={!selectedValueAgency}
                onClick={confirmAgency}
                endIcon={<ArrowForwardIosIcon />}
                variant="contained"
                color="primary"
                sx={{ mt: 12, borderRadius: 5 }}
              >
                ดำเนินการต่อ
              </Button>
            </Grid>

          </Box>
        </Grid>

        {/* Right Section - Image */}
        <Grid
          item
          xs={12}
          md={5}
          sx={{
            display: { xs: "block", md: "block" },
            backgroundColor: "#ffffff",
            justifyContent: "center",
            alignItems: "center",
            maxHeight: 530,
            borderTopRightRadius:12,
            borderBottomRightRadius:12
          }}
        >
          <Box
            component="img"
            src={Agency}
            sx={{
              width: { xs: "100%", md: "100%" },
              maxHeight: { xs: "100%", md: "100%" },
              objectFit: "cover",
              borderTopRightRadius:12,
              borderBottomRightRadius:12
            }}
          />
        </Grid>

      </Grid>

    </Grid>
  );
};

export default SelectAgency;
